import TemplateResetPassword from './TemplateResetPassword'

export default TemplateResetPassword
